module.exports = __webpack_public_path__ + "img/kf2.77a1943c.jpg";